export default function Account(){return <div><h1 className="text-2xl font-black">Account overview</h1><p className="mt-2 text-slate-600">Orders, messages, tickets, wishlist and returns are available here.</p></div>;}
